module.exports = __webpack_public_path__ + "img/card_blue_bg.ec3c8807.png";